import { useRef, useState } from 'react'
import FormDrawer from '../../common/form-drawer'
import usePayrollEssentials from 'hooks/usePayrollEssentials';
import {  togglePfaModal } from 'store/entities/payroll/payrollSetup/action';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from 'react-toastify';

const PfaSetupModal = ({toggleModal}) => {
const {dispatch, useSelector} = usePayrollEssentials()
const [items, setItems] = useState([{id: 1}]);
const {isPfaModalOpen} = useSelector((state) => state.entities.payrollSetup)
const submitRef = useRef()

    const onSubmit = (e) => {
        e.preventDefault()
        // toggleModal()
    }

    const updateCode = (e, id) => {
        const name = e.target.name
        const value = e.target.value
        const newItems = items.map((item) => item.id === id ? {...item, [name]: value} : item)
        setItems(newItems)
    }

    const increment = () => { setItems([...items, {id: items.length + 1}])}
    const onDelete = (id) => {
        if(items.length === 1) {
            toast.error("Cannot delete default item")
        } else {
            setItems([...items.filter(item => item.id !== id)])}
        }

    return (
            <FormDrawer display="center" size="lg" isOpen={isPfaModalOpen} setIsOpen={() => dispatch(togglePfaModal())}>
                    <div className="p-7">
                        <div className="mb-5">
                            <p className="mb-1 font-semibold">Add Company PFA Code(s)</p>
                        </div>
                    <form action="" onSubmit={onSubmit}>
                        {items.map((item, idx) => {
                            return <div key={idx} className="w-full flex items-center mb-7">
                                            <div className='w-full'>
                                                <p className="text-xs lt-gray mb-1">Pension Fund Administrator</p>
                                                <select name="pfa_name" required onChange={(e) => updateCode(e, item.id)} className="form-input">
                                                    <option value="">Select admin</option>
                                                    <option value="Admin 1">Admin 1</option>
                                                    <option value="Admin 2">Admin 2</option>
                                                </select>
                                            </div>
                                                <div className='mx-2' />
                                            <div className='w-full'>
                                                <p className="text-xs lt-gray mb-2">PFA Code</p>
                                                <input type="text" placeholder='Enter Code' required onChange={(e) => updateCode(e, item.id)} name='pfa_code' className="form-input" />
                                            </div>
                                            <div className="pt-6 ml-4">
                                                <FontAwesomeIcon onClick={() => onDelete(item.id)} icon="times" className="ml-1 cursor-pointer" />
                                            </div>
                                </div>
                        })}
                        <button style={{display: 'none'}} ref={submitRef} type="submit">submit</button>
                    </form>
                        <div className="w-full flex items-center mt-5">
                            <button onClick={increment} type='button' className="text-ep-primary-600 mr-4 lg:mr-6 text-sm">Add New Administrator</button>
                            <button onClick={() => submitRef.current.click()} className="btn btn-sm pb-1.5 btn-ep-primary">Save</button>
                        </div>
                </div>
            </FormDrawer>
        )
}

export default PfaSetupModal